export function SET_CURRENT_CONTACT(state, contact) {
  state.currentContactData = contact;
}

export function CLEAR_CURRENT_CONTACT(state) {
  state.currentContactData = null;
}
